import { Directive, ElementRef, HostListener, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: 'input[autoDir], textarea[autoDir], div[autoDir], p[autoDir], span[autoDir], td[autoDir]',
  standalone: false
})
export class AutoDirDirective implements OnInit, OnDestroy {
  private readonly arabicRe = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
  private observer?: MutationObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    this.applyDir(this.currentValue());

    // For non-input elements, text content is set by Angular interpolation or
    // programmatically — the 'input' event never fires. Use MutationObserver.
    const el = this.el.nativeElement;
    if (!(el instanceof HTMLInputElement) && !(el instanceof HTMLTextAreaElement)) {
      this.observer = new MutationObserver(() => {
        this.applyDir(this.currentValue());
      });
      this.observer.observe(el, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  @HostListener('input')
  onInput(): void {
    this.applyDir(this.currentValue());
  }

  private currentValue(): string {
    const el = this.el.nativeElement;
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      return el.value;
    }
    return el.textContent || '';
  }

  private applyDir(value: string): void {
    const first = (value || '').trimStart()[0];
    this.el.nativeElement.dir = first && this.arabicRe.test(first) ? 'rtl' : 'ltr';
  }
}
